/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Schottisch_Gaelisch3Inputs */

const en__field__enum_nativelanguage_schottisch_gaelisch3 = /** @type {(inputs: _Field__Enum_Nativelanguage_Schottisch_Gaelisch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schottisch_Gaelisch`)
};

const de__field__enum_nativelanguage_schottisch_gaelisch3 = /** @type {(inputs: _Field__Enum_Nativelanguage_Schottisch_Gaelisch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schottisch_Gaelisch`)
};

/**
* | output |
* | --- |
* | "Schottisch_Gaelisch" |
*
* @param {_Field__Enum_Nativelanguage_Schottisch_Gaelisch3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_schottisch_gaelisch3 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Schottisch_Gaelisch3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Schottisch_Gaelisch3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_schottisch_gaelisch3(inputs)
	return de__field__enum_nativelanguage_schottisch_gaelisch3(inputs)
});
export { _field__enum_nativelanguage_schottisch_gaelisch3 as "_field__enum_nativeLanguage_Schottisch_Gaelisch" }